import { APP_DESCRIPTION, APP_NAME } from './env';

export const pageDefaultData = {
    title: APP_NAME as string,
    description: APP_DESCRIPTION as string,
    photo: 'cc254045-9753-4428-8960-ae826e43399a',
    content: '',
};